import React from 'react';

const ImageBanner = () => {
    return (
        <a href="#" className="image-banner-wrapper d-block">
            <img src="./assets/sample-image/006_galaxynote20ultra_budslive_watch3.png" alt="banner" className="image br-4"/>
        </a>
    );
};

export default ImageBanner;
